import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const ValueTagContainer = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
    gap: ${theme.space[4]};
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
`;
